import { MainPage } from "@/pages/MainPage";
import { PointPage } from "@/pages/PointPage";
import { LoginPage } from "@/pages/auth/LoginPage";
import { AttendTerms, PhotoTerms, UseTerms } from "@/data/terms";
import { Routes as DomReroutes, Navigate, Route } from "react-router-dom";

/* 건강 */
import { SpinePage } from "@/pages/spine/SpinePage";
import { PhotoDonePage } from "@/pages/spine/spine-photo/PhotoDonePage";
import { PhotoAgreePage } from "@/pages/spine/spine-photo/PhotoAgreePage";
import { PhotoGuide01Page } from "@/pages/spine/spine-photo/PhotoGuide01Page";
import { PhotoPreviewPage } from "@/pages/spine/spine-photo/PhotoPreviewPage";

/* 운동 */
import { ExercisePage } from "@/pages/exercise/EventExercise";
import { ExerciseByPartPage } from "@/pages/exercise/ExerciseByPartPage";

/* 응원 */
import { CommentPage } from "@/pages/comment/CommentPage";
import { CommentWritePage } from "@/pages/comment/CommetWritePage";
import { CommentHistoryPage } from "@/pages/comment/CommentHistoryPage";

/* 회원가입 */
import { JoinTypePage } from "@/pages/auth/join/JoinTypePage";
import { AgreeUsePage } from "@/pages/auth/join/AgreeUsePage";
import { JoinDonePage } from "@/pages/auth/join/JoinDonePage";
import { AgreeAttendPage } from "@/pages/auth/join/AgreeAttendPage";
import { JoinAccountFormPage } from "@/pages/auth/join/JoinAccountFormPage";
import { JoinStudentFormPage } from "@/pages/auth/join/JoinStudentFormPage";
import { JoinGuardianFormPage } from "@/pages/auth/join/JoinGuardianFormPage";
import { JoinGuardianConnectPage } from "@/pages/auth/join/JoinGuardianConnectPage";

/* 설정 */
import PrivateRoute from "./PrivateRoute";
import { FindIdPage } from "@/pages/auth/FindIdPage";
import { FindPwPage } from "@/pages/auth/FIndPwPage";
import { CheckIdPage } from "@/pages/auth/CheckIdPage";
import { CheckPwPage } from "@/pages/auth/CheckPwPage";
import { SettingPage } from "@/pages/setting/SettingPage";
import { ChangePwPage } from "@/pages/auth/ChangePwPage";
import { UserInfoPage } from "@/pages/setting/user/UserInfoPage";
import { TermsListPage } from "@/pages/setting/terms/TermsListPage";
import { UserIdEditPage } from "@/pages/setting/user/UserIdEditPage";
import { UserPwEditPage } from "@/pages/setting/user/UserPwEditPage";
import { InquiryFaqPage } from "@/pages/setting/inquiry/InquiryFaqPage";
import { ExerciseSetPage } from "@/pages/exercise/ExerciseSetPage";
import { TermsDetailPage } from "@/pages/setting/terms/TermsDetailPage";
import { AlarmDetailPage } from "@/pages/setting/push-alarm/AlarmDetailPage";
import { NoticeDetailPage } from "@/pages/setting/notice/NoticeDetailPage";
import { PhotoGuide02Page } from "@/pages/spine/spine-photo/PhotoGuide02Page";
import { PhotoGuide03Page } from "@/pages/spine/spine-photo/PhotoGuide03Page";
import { PhotoGuide04Page } from "@/pages/spine/spine-photo/PhotoGuide04Page";
import { SettingAlarmPage } from "@/pages/setting/push-alarm/SettingAlarmPage";
import { SettingNoticePage } from "@/pages/setting/notice/SettingNoticePage";
import { SettingInquiryPage } from "@/pages/setting/inquiry/SettingInquiryPage";
import { InquiryContactPage } from "@/pages/setting/inquiry/InquiryContactPage";
import { HealthInfoEditPage } from "@/pages/setting/health-info/HealthInfoEditPage";
import { SettingEditTypePage } from "@/pages/setting/SettingEditType";
import { SettingWithdrawPage } from "@/pages/setting/SettingWithdrawPage";
import { StudentInfoEditPage } from "@/pages/setting/user/StudentInfoEditPage";
import { GuardianInfoEditPage } from "@/pages/setting/guardian/GuardianInfoEditPage";
import { SettingHealthInfoPage } from "@/pages/setting/health-info/SettingHealthInfoPage";
import { InquiryContactWritePage } from "@/pages/setting/inquiry/InquiryContactWritePage";
import { SettingGuardianConnectPage } from "@/pages/setting/guardian/SettingGuardianConnectPage";

interface RouterItem {
  path: string;
  element: React.ReactNode;
  withAuthorization: boolean;
  pageTitle?: string;
}

const routerItems: RouterItem[] = [
  /* 메인 홈 */
  {
    path: "/home",
    element: <MainPage />,
    withAuthorization: true,
  },
  /* 로그인 */
  {
    path: "/auth/login",
    element: <LoginPage />,
    withAuthorization: false,
  },

  /* 회원가입 */
  {
    path: "/auth/join/type",
    element: <JoinTypePage />,
    withAuthorization: false,
  },
  {
    path: "/auth/account/find-id",
    element: <FindIdPage />,
    withAuthorization: false,
  },
  {
    path: "/auth/account/find-password",
    element: <FindPwPage />,
    withAuthorization: false,
  },
  {
    path: "/auth/account/check-id",
    element: <CheckIdPage />,
    withAuthorization: false,
  },
  {
    path: "/auth/account/check-password",
    element: <CheckPwPage />,
    withAuthorization: false,
  },
  {
    path: "/auth/account/change-password",
    element: <ChangePwPage />,
    withAuthorization: false,
  },
  {
    path: "/auth/join/agree-attend",
    element: <AgreeAttendPage />,
    withAuthorization: false,
  },
  {
    path: "/auth/join/agree-use",
    element: <AgreeUsePage />,
    withAuthorization: false,
  },
  {
    path: "/auth/join/account-form",
    element: <JoinAccountFormPage />,
    withAuthorization: false,
  },
  {
    path: "/auth/join/student-form",
    element: <JoinStudentFormPage />,
    withAuthorization: false,
  },
  {
    path: "/auth/join/guardian-form",
    element: <JoinGuardianFormPage />,
    withAuthorization: false,
  },
  {
    path: "/auth/join/guardian-connect",
    element: <JoinGuardianConnectPage />,
    withAuthorization: false,
  },
  {
    path: "/auth/join/done",
    element: <JoinDonePage />,
    withAuthorization: false,
  },

  /* 내 척추건강 */
  {
    path: "/spine",
    element: <SpinePage />,
    withAuthorization: true,
  },
  {
    path: "/spine/photo-agree",
    element: <PhotoAgreePage />,
    withAuthorization: true,
  },
  {
    path: "/spine/photo-guide01",
    element: <PhotoGuide01Page />,
    withAuthorization: true,
  },
  {
    path: "/spine/photo-guide02",
    element: <PhotoGuide02Page />,
    withAuthorization: true,
  },
  {
    path: "/spine/photo-guide03",
    element: <PhotoGuide03Page />,
    withAuthorization: true,
  },
  {
    path: "/spine/photo-guide04",
    element: <PhotoGuide04Page />,
    withAuthorization: true,
  },
  {
    path: "/spine/photo-preview",
    element: <PhotoPreviewPage />,
    withAuthorization: true,
  },
  {
    path: "/spine/photo-done",
    element: <PhotoDonePage />,
    withAuthorization: true,
  },

  /* 운동제안 */
  {
    path: "/exercise",
    element: <ExercisePage />,
    withAuthorization: false,
  },
  {
    path: "/exercise/partby/:exercisePartCategory",
    element: <ExerciseByPartPage />,
    withAuthorization: false,
  },
  {
    path: "/exercise/set/:exerciseSetQuater",
    element: <ExerciseSetPage />,
    withAuthorization: false,
  },

  /* 나의 건강포인트 */
  {
    path: "/point",
    element: <PointPage />,
    withAuthorization: true,
  },

  /* 메시지 관리 */
  {
    path: "/comment",
    element: <CommentPage />,
    withAuthorization: true,
  },
  {
    path: "/comment/history",
    element: <CommentHistoryPage />,
    withAuthorization: true,
  },
  {
    path: "/comment/write",
    element: <CommentWritePage />,
    withAuthorization: true,
  },

  /* 설정 */
  {
    path: "/setting",
    element: <SettingPage />,
    withAuthorization: true,
  },
  {
    path: "/setting/user",
    element: <UserInfoPage />,
    withAuthorization: true,
  },
  {
    path: "/setting/user-editType",
    element: <SettingEditTypePage />,
    withAuthorization: true,
  },
  {
    path: "/setting/user/account-id-edit",
    element: <UserIdEditPage />,
    withAuthorization: true,
  },
  {
    path: "/setting/user/account-pw-edit",
    element: <UserPwEditPage />,
    withAuthorization: true,
  },
  {
    path: "/setting/user/student-edit",
    element: <StudentInfoEditPage />,
    withAuthorization: true,
  },
  {
    path: "/setting/health-info",
    element: <SettingHealthInfoPage />,
    withAuthorization: true,
  },
  {
    path: "/setting/health-info/edit",
    element: <HealthInfoEditPage />,
    withAuthorization: true,
  },
  {
    path: "/setting/guardian",
    element: <SettingGuardianConnectPage />,
    withAuthorization: true,
  },
  {
    path: "/setting/user/guardian-edit",
    element: <GuardianInfoEditPage />,
    withAuthorization: true,
  },
  {
    path: "/setting/notice",
    element: <SettingNoticePage />,
    withAuthorization: true,
  },
  {
    path: "/setting/notice/detail/:id",
    element: <NoticeDetailPage />,
    withAuthorization: true,
  },
  {
    path: "/setting/alarm",
    element: <SettingAlarmPage />,
    withAuthorization: true,
  },
  {
    path: "/setting/alarm/detail/:id",
    element: <AlarmDetailPage />,
    withAuthorization: true,
  },
  {
    // 서비스 문의
    path: "/setting/inquiry",
    element: <SettingInquiryPage />,
    withAuthorization: true,
  },
  {
    // 서비스 문의 > 자주 묻는 질문 > 카테고리 분류(default: ACCOUNT)
    path: "/setting/inquiry/faq/:faqCategory",
    element: <InquiryFaqPage />,
    withAuthorization: true,
  },
  {
    // 서비스 문의 > 1:1 문의
    path: "/setting/inquiry/contacts",
    element: <InquiryContactPage />,
    withAuthorization: true,
  },
  {
    // 서비스 문의 > 1:1 문의 > 작성
    path: "/setting/inquiry/contacts/write",
    element: <InquiryContactWritePage />,
    withAuthorization: true,
  },
  {
    path: "/setting/terms",
    element: <TermsListPage />,
    withAuthorization: true,
  },
  {
    path: "/setting/terms/attend",
    element: (
      <TermsDetailPage title="서비스 이용 안내" text={<AttendTerms />} />
    ),
    withAuthorization: false,
  },
  {
    path: "/setting/terms/use",
    element: (
      <TermsDetailPage
        title="개인정보 수집・이용 및 제3자 제공 약관"
        text={<UseTerms />}
      />
    ),
    withAuthorization: false,
  },
  {
    path: "/setting/terms/photo",
    element: (
      <TermsDetailPage title="사진활용 동의 약관" text={<PhotoTerms />} />
    ),
    withAuthorization: false,
  },
  {
    path: "/setting/withdraw",
    element: <SettingWithdrawPage />,
    withAuthorization: false,
  },
];

export function Routes() {
  return (
    <DomReroutes>
      <Route
        path="/"
        element={<PrivateRoute component={<Navigate to="/home" replace />} />}
      />
      {routerItems
        .filter((route) => route.withAuthorization)
        .map((route: RouterItem) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={<PrivateRoute component={route.element} />}
            />
          );
        })}

      {routerItems
        .filter((route) => !route.withAuthorization)
        .map((route: RouterItem) => {
          return (
            <Route key={route.path} path={route.path} element={route.element} />
          );
        })}
    </DomReroutes>
  );
}
